import { devLog } from "../../../utils/devLogger";
import { callApi, HttpMethod } from "../../methods/callApi";
import { flutterBridge } from "../../../utils/flutterBridge";

export async function callUserApi<T = any>({
  title,
  url,
  method = 'POST',
  body,
  params,
  isCallPageLoader = false,
  withToken = false, // 기본값을 false로 설정 (대부분의 유저 API는 토큰 불필요)
  withRefreshToken = false, // refresh token 사용 옵션 추가
}: {
  title: string;
  url: string;
  method?: HttpMethod;
  body?: Record<string, any>;
  params?: Record<string, any>;
  isCallPageLoader?: boolean;
  withToken?: boolean;
  withRefreshToken?: boolean; // refresh token 사용 여부
  onOpenLoader?: () => void;
  onCloseLoader?: () => void;
}): Promise<{ data: T; headers?: Headers }> {
  devLog("유저 API 요청:", title);

  // 토큰 처리
  let accessToken: string | undefined = undefined;
  let customHeaders: Record<string, string> = {};
  
  // 언어 설정 헤더 추가
  const savedLang = localStorage.getItem('appLang');
  const currentLang = savedLang || (navigator.language.startsWith('ko') ? 'ko' : 'en');
  customHeaders['X-Language'] = currentLang;
  devLog("언어 헤더 설정:", currentLang);
  
  if (withToken) {
    accessToken = localStorage.getItem('accessToken') || undefined;
    devLog("Access 토큰 사용:", !!accessToken);
  } else if (withRefreshToken) {
    // Flutter에서 받은 refresh token을 Authorization Bearer 헤더로 사용
    const refreshToken = localStorage.getItem('refreshToken') || 
                        flutterBridge.getReceivedRefreshToken() || undefined;
    if (refreshToken) {
      accessToken = refreshToken; // refresh token을 accessToken 자리에 넣어 Bearer로 전송
      devLog("Refresh 토큰을 Bearer로 사용:", !!refreshToken);
    }
  }

  const result = await callApi({
    title,
    url,
    method,
    params,
    accessToken,
    headers: customHeaders,
    body,
    isCallPageLoader,
  });

  return result;
}

// 편의 함수들
export const callUserApiGet = <T = any>(params: Omit<Parameters<typeof callUserApi>[0], 'method'>) => 
  callUserApi<T>({ ...params, method: 'GET' });

export const callUserApiPost = <T = any>(params: Omit<Parameters<typeof callUserApi>[0], 'method'>) => 
  callUserApi<T>({ ...params, method: 'POST' });

export const callUserApiPut = <T = any>(params: Omit<Parameters<typeof callUserApi>[0], 'method'>) => 
  callUserApi<T>({ ...params, method: 'PUT' });

export const callUserApiPatch = <T = any>(params: Omit<Parameters<typeof callUserApi>[0], 'method'>) => 
  callUserApi<T>({ ...params, method: 'PATCH' });

export const callUserApiDelete = <T = any>(params: Omit<Parameters<typeof callUserApi>[0], 'method'>) => 
  callUserApi<T>({ ...params, method: 'DELETE' });
